















import Vue from 'vue';

export default Vue.extend({
  name: 'Login',
  props: {
    next: {
      type: String,
      default: '/',
    },
  },
  data() {
    return {
      username: '',
      password: '',
      authError: false,
    };
  },
  methods: {
    async login() {
      try {
        this.authError = false;
        await this.$store.dispatch('login', { username: this.username, password: this.password });
        await this.$router.push(this.next);
      } catch (e) {
        this.authError = true;
      }
    },
  },
});
